import React from "react";
import PropTypes from "prop-types";

import S from "./BasicTable.module.css";
import { Link } from "react-router-dom";

export default function BasicTable({ headers, items = [], itemKey }) {
  if (!headers || !headers.length) {
    throw new Error("<BasicTable /> headers is required.");
  }

  const headerKeys = headers.map((header) => header.value);

  if (itemKey === null) {
    itemKey = headerKeys[0];
  }
  const shouldRenderHeader = headers.some(header => header.text !== '');

  const tableClassName = itemKey === "buyMobileTable" ? S.buyTableWrap : S.tableWrap;

  return (
    <table className={tableClassName}>
      {shouldRenderHeader && (
        <thead className={S.tableHeader}>
          <tr>
            {headers.map((header, index) => {
              const cellProps = {
                className: header?.widthClass ? header.widthClass.split(' ').map(cls => S[cls]).join(' ') : "",
                rowSpan: header?.rowSpan || 1, 
                colSpan: header?.colSpan || 1, 
              };
              if (header?.text === null) return <></>;
              return (
                <th 
                  key={index} 
                  className={`${S[header.widthClass]}`}
                  {...cellProps}
                >
                  {header.text}
                </th>
              );
            })}
          </tr>
        </thead>
      )}
      <tbody>
      {(items.length === 0 && (itemKey === "buyMobileTable" || itemKey === "buyTable")) ? (
        <td colSpan="4" className={S.nullTableBody}>
          목록이 없습니다.
        </td>
      ):(
        items.map((row, rowIndex) => (
          <tr 
              key={rowIndex}
              data-index={row.idx ? row.idx : null}
            > 
          
              {headers.map((header, index) => {
                const value = row[header.value];
                const cellProps = {
                  key: index,
                  className: value?.className ? value.className.split(' ').map(cls => S[cls]).join(' ') : "",
                  rowSpan: value?.rowSpan || 1, 
                  colSpan: value?.colSpan || 1, 
                };

                if (value?.text === null) return <></>;
                  
                return (
                  <td key={index} {...cellProps}>
                    {row.url && row.idx ? (
                      <Link to={`/${row.url}/${row.idx}`}>
                        {value?.text}
                      </Link>
                    ) : value?.text}
                  </td>
                );
              })}

            </tr>
        ))
      )}
      </tbody>
    </table>
  );
}

BasicTable.propTypes = {
  headers: PropTypes.arrayOf(
    PropTypes.shape({
      // text: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    })
  ).isRequired,
  items: PropTypes.arrayOf(PropTypes.object),
  itemKey: PropTypes.string,
};
